/**
 * Default campaign per country — hook for localStorage cache.
 * For Media Devoted | Created By Ciro Autiero
 */

import { useCallback } from 'react';
import { getDefaultCampaign, setDefaultCampaign } from '../utils/defaultCampaignStorage';

export function useDefaultCampaign(countryKey: string) {
  const defaultCampaignId = countryKey ? getDefaultCampaign(countryKey) : null;

  const saveDefault = useCallback(
    (campaignId: number) => {
      if (!countryKey || campaignId <= 0) return;
      setDefaultCampaign(countryKey, campaignId);
    },
    [countryKey],
  );

  return {
    defaultCampaignId,
    setDefaultCampaign: saveDefault,
  };
}
